import withTitle from '../shared/HOCs/withTitle';
import NewPassword from '../components/NewPassword';

export default withTitle('New password')(NewPassword);
